export default __webpack_public_path__ + "static/media/solid_biofuel.8d9ada13.png";